"use strict";

import Common from "./Common";
import GameScene from "./../scenes/GameScene";

/**
 * @class
 */
export default
class Application {
    constructor() {

        //--bind the asset manager functions so we can call them with a short local variable--//
        Common.assets.texture = Common.assets.texture.bind(Common.assets);
        Common.assets.json = Common.assets.json.bind(Common.assets);

        //--load saves--//
        Common.loadMute();
        Common.loadGame();

        const j = Common.assets.json;
        Common.config = j("config");

    }

    init() {

       this.showGameScene();
    }

    showGameScene() {
        const scene = new GameScene();
        scene.signals.next.add(function () {
       // this.showQuizScene();
        }, this);

        Common.scene.show(scene);
        return scene;
    }

}
